import Layout from '@layout/Index'

export const settings = [
  {
    path: '/settings',
    component: Layout,
    children: [
      {
        path: 'change-password',
        component: () => import(/* webpackChunkName: "project-chart" */ './pages/ChangePassword.vue'),
        name: '修改密码',
        meta: {
          title: '修改密码',
        },
      },
      {
        path: 'set-project-config',
        component: () => import(/* webpackChunkName: "SetProjectConfig" */ './pages/SetProjectConfig.vue'),
        name: '项目审核人管理',
        meta: {
          title: '项目审核人管理',
        },
      },
      {
        path: 'set-receipt-apply-config',
        component: () => import(/* webpackChunkName: "SetReceiptApplyConfig" */ './pages/SetReceiptApplyConfig.vue'),
        name: '开票抄送人管理',
        meta: {
          title: '开票抄送人管理',
        },
      },
    ],
  },
  {
    path: '/change-password',
    component: () => import(/* webpackChunkName: "project-chart" */ './pages/ChangePassword.vue'),
    name: '修改密码',
    meta: {
      title: '修改密码',
      isBeforLogin: true,
    },
  }
]



// WEBPACK FOOTER //
// ./src/views/settings/settings.route.js